import type { ReactNode } from "react";
import { useAppSettings } from "../appSettings";
import { cn } from "../lib/utils";
import { MessageCopyButton } from "./chat/MessageCopyButton";
import { WordWrapButton } from "./WordWrapButton";

export function TextOutput({
  title,
  children,
  copyText,
  copyLabel,
  className,
  contentClassName,
}: {
  title: string;
  children: ReactNode;
  copyText?: string;
  copyLabel?: string;
  className?: string;
  contentClassName?: string;
}) {
  const { settings, updateSettings } = useAppSettings();
  return (
    <div
      data-word-wrap={settings.wordWrap}
      className={cn(
        "text-output min-w-0 overflow-hidden rounded-lg border border-border bg-muted/30",
        className,
      )}
    >
      <div className="flex items-center justify-between gap-3 px-3 py-2 text-xs text-muted-foreground">
        <span className="min-w-0 truncate">{title}</span>
        <div className="flex shrink-0 items-center gap-1">
          <WordWrapButton
            enabled={settings.wordWrap}
            onToggle={() => updateSettings({ wordWrap: !settings.wordWrap })}
          />
          {copyText !== undefined && (
            <MessageCopyButton text={copyText} label={copyLabel ?? "Copy text"} />
          )}
        </div>
      </div>
      <div className={cn("text-output-content min-w-0 overflow-auto px-3 pb-3", contentClassName)}>
        {children}
      </div>
    </div>
  );
}
